import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
// eslint-disable-next-line no-restricted-imports
import { assignInlineVars } from "@vanilla-extract/dynamic";
import React from "react";
import { SDUIOnClickHandler } from "@faire/retailer/components/SDUI/__internal__/SDUIOnClickHandler/SDUIOnClickHandler";
import { numberToPixel } from "@faire/retailer/components/SDUI/__internal__/Styling/conversions";
import { SDUIImageElementRenderer } from "@faire/retailer/components/SDUI/ComponentRenderers/Image/SDUIImageElementRenderer";
import { SDUIRichTextRenderer } from "@faire/retailer/components/SDUI/ComponentRenderers/RichText/SDUIRichTextRenderer";
import { getGridSize, getMainImageDimensions, getSecondaryImageDimensions } from "@faire/retailer/components/SDUI/ComponentRenderers/Tile/__internal__/imageGalleryTileLayoutUtils";
import * as styles from "@faire/retailer/components/SDUI/ComponentRenderers/Tile/__internal__/styles/SDUIImageGalleryTileRendererStyles.css";
import { SDUITypographyRenderer } from "@faire/retailer/components/SDUI/ComponentRenderers/Typography/SDUITypographyRenderer";
var AVATAR_IMAGE_SIZE = 48;
export var SDUIImageGalleryTileRenderer = function(param) {
    var tileElement = param.tileElement, loggingData = param.loggingData, renderBehaviour = param.renderBehaviour;
    var on_click = tileElement.on_click;
    var image_gallery_tile = tileElement.image_gallery_tile;
    if (!image_gallery_tile) {
        return null;
    }
    var header_text = image_gallery_tile.header_text, sub_header_text = image_gallery_tile.sub_header_text, description_text = image_gallery_tile.description_text, secondary_images = image_gallery_tile.secondary_images, avatar_image = image_gallery_tile.avatar_image, main_image = image_gallery_tile.main_image;
    if (!main_image || !avatar_image) {
        return null;
    }
    // The ImageGallery currently only supports rendering up to two secondary images
    var secondaryImagesToShow = secondary_images.slice(0, 2);
    var mainImageDimensions = getMainImageDimensions(secondaryImagesToShow.length);
    var secondaryImageDimensions = getSecondaryImageDimensions(secondaryImagesToShow.length);
    return /*#__PURE__*/ _jsxs(SDUIOnClickHandler, {
        className: styles.imageGalleryTileWrapper,
        onClickActions: on_click,
        loggingData: loggingData,
        logLegacyClickEvent: true,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.gridWrapper,
                style: {
                    gridTemplateColumns: getGridSize(secondaryImagesToShow.length).columns,
                    gridTemplateRows: getGridSize(secondaryImagesToShow.length).rows
                },
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.mainImage,
                        style: assignInlineVars(_define_property({}, styles.varNumSecondaryImages, "".concat(secondaryImagesToShow.length))),
                        children: /*#__PURE__*/ _jsx(SDUIImageElementRenderer, {
                            imageElement: main_image,
                            loggingData: loggingData,
                            imageStyles: {
                                width: "100%",
                                height: numberToPixel(mainImageDimensions.height)
                            },
                            optimizeImageOptions: secondaryImagesToShow.length === 0 ? _object_spread({
                                resizeMethod: "pad",
                                ignoreResizeTag: true,
                                background: Core.surface.subdued
                            }, mainImageDimensions) : _object_spread({
                                resizeMethod: "fill"
                            }, mainImageDimensions),
                            renderBehaviour: renderBehaviour
                        })
                    }),
                    secondaryImagesToShow.map(function(image, index) {
                        return /*#__PURE__*/ _jsx(SDUIImageElementRenderer, {
                            imageElement: image,
                            loggingData: loggingData,
                            optimizeImageOptions: _object_spread({
                                resizeMethod: "fill"
                            }, secondaryImageDimensions),
                            imageStyles: {
                                width: "100%",
                                height: numberToPixel(secondaryImageDimensions.height)
                            },
                            renderBehaviour: renderBehaviour
                        }, index);
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.gridTileInfo,
                children: [
                    /*#__PURE__*/ _jsx(SDUIImageElementRenderer, {
                        imageElement: avatar_image,
                        loggingData: loggingData,
                        renderBehaviour: renderBehaviour,
                        optimizeImageOptions: {
                            resizeMethod: "fill",
                            width: AVATAR_IMAGE_SIZE,
                            height: AVATAR_IMAGE_SIZE
                        },
                        imageStyles: {
                            width: numberToPixel(AVATAR_IMAGE_SIZE),
                            height: numberToPixel(AVATAR_IMAGE_SIZE),
                            isCircular: true
                        }
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            header_text ? /*#__PURE__*/ _jsx(SDUITypographyRenderer, {
                                textElement: header_text,
                                loggingData: loggingData
                            }) : null,
                            sub_header_text ? /*#__PURE__*/ _jsx(SDUITypographyRenderer, {
                                textElement: sub_header_text,
                                loggingData: loggingData
                            }) : null,
                            description_text ? /*#__PURE__*/ _jsx(SDUIRichTextRenderer, {
                                richTextElement: description_text
                            }) : null
                        ]
                    })
                ]
            })
        ]
    });
};
